import { PrivaWizardToolbarButton } from '@priva/components/wizard/toolbar';

export const wizardToolbarButtons: PrivaWizardToolbarButton[] = [
    {
        id: 'prev',
        importance: 'Tertiary',
        iconState: 'Left',
        iconClass: 'fas fa-arrow-left',
        text: 'GENERAL.ACTION.PREV',
        hidden: true,
        area: 'Start',
    },
    { id: 'reset', importance: 'Tertiary', text: 'GENERAL.ACTION.RESET' },
    {
        id: 'next',
        importance: 'Secondary',
        iconState: 'Right',
        iconClass: 'fas fa-arrow-right',
        text: 'GENERAL.ACTION.NEXT',
    },
    { id: 'submit', importance: 'Primary', text: 'GENERAL.ACTION.FINISH', hidden: true },
];
